<template>
    <div style="display: flex;flex-direction:column; height: 100vh;" id="index">
       <header-h @changeLabelModel="changeLabelModel" style="width: 100%;" @logoutSave="logoutSave"></header-h>
       <div class="box" >
         <!-- leftpart -->
            <div class="left" :style="{'height': imgHeight+'px'}">
                <div class="btn" v-if="btnFlag">
                  <input id="file2" type="file" hidden webkitdirectory @change="fileChange">
                  <el-button @click="refreshFun">
                            <img src="@/assets/images/refresh.png" class="imgclass_1">
                            Refresh
                    </el-button>
                </div>
                <div class="btn" v-else>
                    <input id="file" type="file" hidden webkitdirectory @change="fileChange">
                    <el-button @click="btnChange(0)">
                            <img src="@/assets/images/openfile.png" class="imgclass_1">
                            File Upload
                    </el-button>
                </div>
                <div class="left_1">
                    <user-info></user-info>
                </div>
                <div class="left_2">
                    <slicePart ref='slicepart' :sliceData="$store.state.sliceData" @changeSclie="changeSclie" :scanIndex="$store.state.scanIndex"></slicePart>
                </div>
                <div class="left_4" ref="left4">
                    <thicknessPart :list="$store.state.thicknesslist"></thicknessPart>
                </div>
            </div>
         <!-- Midpart -->
           <div class="mid">
                <div class="mid_top" :style="{'justify-content':btnFlag?'space-between':'right'}">
                       <div class="mid_top_l" v-if="btnFlag" >
                          <el-row style="text-align: left;">
                            <el-col>
                              <el-select
                            ref="selectSearch1"
                            v-model="labelList"
                            multiple
                            collapse-tags
                            collapse-tags-tooltip
                            placeholder="Labeled by"
                            class="selectClass"
                            @change="labelChange"
                            >
                                <el-option-group
                                    v-for="(group,index) in labeloptions"
                                    :key="index"
                                    >
                                    <el-option
                                        v-for="item in group.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        :disabled="item.disabled"
                                        style="--el-color-primary:#3AC0CB"
                                    />
                                </el-option-group>
                            <div style="border: 1px solid #DDDDDD;width:100%;"></div>
                            <div style="display: flex;justify-content:space-between;margin:5px 10px">
                                <el-button plain style="--el-color-primary:#3AC0CB;color:#828282" @click="ClearAllFun(0)">Clear all</el-button>
                                <el-button plain style="--el-color-primary:#3AC0CB;background-color: #3AC0CB;color:#ffffff" @click="ApplySearch">Apply</el-button>
                            </div>
                            </el-select>
                            <el-select
                                v-model="diagnosisList"
                                ref="selectSearch2"
                                multiple
                                collapse-tags
                                collapse-tags-tooltip
                                placeholder="Diagnosis"
                                class="selectClass"
                                @change="diagnosisChange"
                                >
                                    <el-option-group
                                        v-for="(group,index) in diagnosisoptions"
                                        :key="index"
                                        >
                                        <el-option
                                            v-for="item in group.options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                            :disabled="item.disabled"
                                            style="--el-color-primary:#3AC0CB"
                                        />
                                    </el-option-group>
                                <div style="border: 1px solid #DDDDDD;width:100%;"></div>
                                <div style="display: flex;justify-content:space-between;margin:5px 10px">
                                    <el-button plain style="--el-color-primary:#3AC0CB;color:#828282" @click="ClearAllFun(1)">Clear all</el-button>
                                    <el-button plain style="--el-color-primary:#3AC0CB;background-color: #3AC0CB;color:#ffffff" @click="ApplySearch">Apply</el-button>
                                </div>
                            </el-select>
                            <el-select
                                v-model="findingList"
                                ref="selectSearch3"
                                multiple
                                collapse-tags
                                collapse-tags-tooltip
                                placeholder="Finding"
                                class="selectClass"
                                >
                                <el-option
                                    v-for="item in findingoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    style="--el-color-primary:#3AC0CB"
                                >
                                </el-option>
                                <div style="border: 1px solid #DDDDDD;width:100%;"></div>
                                <div style="display: flex;justify-content:space-between;margin:5px 10px">
                                    <el-button plain style="--el-color-primary:#3AC0CB;color:#828282" @click="ClearAllFun(2)">Clear all</el-button>
                                    <el-button plain style="--el-color-primary:#3AC0CB;background-color: #3AC0CB;color:#ffffff" @click="ApplySearch">Apply</el-button>
                                </div>
                            </el-select>
                            <el-input
                                v-model="patientdata"
                                placeholder="Search ID"
                                class="selectClass"
                                style="height:32px;"
                                >
                                <template #append>
                                    <el-button class="search" @click="ApplySearch">Search</el-button>
                                </template>
                            </el-input>
                            <!-- 病患ID -->
                            <!-- <el-input
                                v-model="patientID"
                                placeholder="Search patientID"
                                class="selectClass"
                                style="height:32px;"
                                >
                                <template #append>
                                    <el-button class="search" @click="ApplySearch">Search</el-button>
                                </template>
                            </el-input> -->
                            <el-button v-show="clearFlag" link style="color:#3AC0CB;height: 32px;" @click="ClearAllFun()">Clear all</el-button>
                            </el-col>
                          </el-row>
                        </div>
                        <el-button style="--el-color-primary:#3AC0CB;height:32px;" @click="deleteMark" :disabled="$store.state.findIndex===undefined?true:false"><el-icon><Delete /></el-icon> Delete</el-button>
                </div>
                <div ref="midBot" class="mid_bot">
                    <carousel ref='carousel' :sliceData="$store.state.sliceData" :imgIndex="$store.state.sliceIndex" :imgHeight="imgHeight" :imgWidth="imgWidth" :drawData="drawData"></carousel>
                </div>
           </div>
          <!-- Rightpart -->
            <div class="right" :style="{'height': imgHeight+50+'px'}">
                <operatePart ref="operatePart" :btnFlag="btnFlag" :sliceIndex="$store.state.sliceIndex" :scanIndex="$store.state.scanIndex" :scanTotal="$store.getters.getScanNumTotal" @changeNum="changeNum" @drawFun="drawFun" :patientTotal="$store.getters.getPatientTotal"  @changeLabelModel="changeLabelModel"
                ></operatePart>
            </div>
       </div>
       <!-- 上傳文件 -->
       <el-dialog v-model="centerDialogVisible" title="開啟資料夾" width="50%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <div style="border-top: 1px solid #dddddd;border-bottom: 1px solid #dddddd;height:300px;display: flex;">
           <div style="width:30%;display: flex;align-items: center;height: 100%;justify-content: center;border-right: 1px solid #dddddd;">
              <img src="@/assets/images/file.png" alt="" style="width: 100px;">
           </div>
           <div style="flex:1;padding:10px 20px;text-align: left;">
              <span style="font-size: 20px;color:#468287;">{{form.imgSavePath }}</span>
              <div  style="width:100%;margin-top: 10px;border-top: 1px solid #dddddd;" v-loading="loading">
                <el-scrollbar ref="scrollbar" style="height:230px;" class="scall_class">
                  <div v-for="(item,index) in form.list" :key="index">
                    <span>{{ item }}</span>
                  </div>
                </el-scrollbar>
              </div>
           </div>
        </div>
        <template #footer >
          <span class="dialog-footer">
            <el-button @click="centerDialogVisible = false" style="--el-color-primary:#3AC0CB;">取消</el-button>
            <el-button @click="submitUpfile" style="--el-color-primary:#FEAA4C;color:#ffffff;background-color: #FEAA4C;border-color:#FEAA4C" :disabled="loading">開啟</el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 上傳進行中 -->
      <el-dialog
          v-model="dialogVisible"
          title="Uploading..."
          width="30%"
          :before-close="handleClose"
          :close-on-click-modal="false" :close-on-press-escape="false"
          class="cancelDia"
        >
          <div>
            <span>{{uploadedPatNumber}}/{{progressReturnList.length}}pat files uploading</span>
            <div v-for="(item,index) in progressReturnList" :key="index">
              <div v-show="item.showflag">
                 <p>{{item.uploadedFile}}/{{item.patprogesslength}}{{ `  `+item.patprogessKey+'.pat'}}</p>
                 <el-progress :percentage="item.percentage" :color="customColorMethod"></el-progress>
              </div>
            </div>
            <span v-if="promiseReturnNumber.length===progressReturnList.length" style="color: #3AC0CB;">Waiting for request to return...</span>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false,cancelUpload=true,returnVisible=false" style="--el-color-primary:#FEAA4C;color:#ffffff;background-color: #FEAA4C;border-color:#FEAA4C">
                Cancel
              </el-button>
            </span>
          </template>
        </el-dialog>

         <!-- 上傳返回结果 -->
      <el-dialog
          v-model="returnVisible"
          :title="'Upload Completed'"
          width="30%"
          :close-on-click-modal="false" :close-on-press-escape="false"
          class="cancelDia"
        >
          <div style="float: left;"  >
            <div>{{progressReturnList.length}} uploaded</div>
            <div>{{failedfilename.size}} failed</div>
            <div v-if="failedfilename.size!==0">
              (<span v-for="item in failedfilename" :key="item">
              {{ item }},
            </span>
            )
            </div>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <el-button type="primary" @click="cancelUploadFun,returnVisible = false" style="--el-color-primary:#FEAA4C;color:#ffffff;background-color: #FEAA4C;border-color:#FEAA4C">
                OK
              </el-button>
            </span>
          </template>
        </el-dialog>
         <!-- 删除上传 -->
         <el-dialog
          v-model="cancelUpload"
          :title="'Cancel Upload'"
          width="40%"
          :close-on-click-modal="false" :close-on-press-escape="false"
          class="cancelDia"
        >
          <div>
            <span>The upload has not completed, are you sure you want to cancel the upload?</span>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="keepUploadFun" style="--el-color-primary:#3AC0CB;">Keep Uploading</el-button>
              <el-button type="primary" @click="cancelUploadFun" style="--el-color-primary:#FEAA4C;color:#ffffff;background-color: #FEAA4C;border-color:#FEAA4C">
                Cancel Upload
              </el-button>
            </span>
          </template>
        </el-dialog>
      <progressBar :progressVisible="$store.state.progressflag" :progressdata="$store.state.progress" v-if="$store.state.progressflag" @cancelFun="cancelRequest"></progressBar>
    </div>
</template>

<script>
import UserInfo from '@/components/userInfo.vue'
import operatePart from '@/components/operatePart.vue'
import slicePart from '@/components/slicePart.vue'
import thicknessPart from '@/components/thicknessPart.vue'
import carousel from '@/components/Carousel.vue'
// import image3D from '@/components/image3D.vue'
import headerH from '@/components/header.vue'
import { ElMessage, ElLoading } from 'element-plus'
import img1 from '@/assets/images/1.png'
import img2 from '@/assets/images/2.png'
import img3 from '@/assets/images/3.png'
import img4 from '@/assets/images/4.png'
import img5 from '@/assets/images/5.png'
import img6 from '@/assets/images/6.jpg'
import img10 from '@/assets/images/10.jpg'
// import axios from 'axios'
import SparkMD5 from 'spark-md5'
import { formatTimeMills, getImgStyle } from '@/utils/index.js'
// import { getImgStyle } from '@/utils/index.js'
import { batchUpload, getDoctorList, redisClear } from '@/api/index.js'
import { mapState } from 'vuex'
import ProgressBar from '@/components/progressBar.vue'
import 'core-js/actual/array/group'
export default {
  name: 'Index',
  components: {
    UserInfo,
    operatePart,
    headerH,
    slicePart,
    thicknessPart,
    carousel,
    ProgressBar
    // image3D
  },
  data () {
    return {
      datalist: {
        userInfo: {
          name: '张三',
          birthDate: '1933-01-26',
          sex: 'M',
          laterality: 'R',
          ID: '2572',
          scanDate: '2023-02-10[1121490]'
        },
        scanlist: [
          {
            img: img6,
            list: [
              {
                url: img1,
                thicknesslist: {
                  low: [210, 251, 212, 260, 246, 221, 200],
                  lowp: [],
                  cloumn: [239, 255, 212, 260, 210, 321, 220],
                  cloumnp: []
                }
              },
              {
                url: img2,
                thicknesslist: {
                  low: [210, 261, 212, 267, 246],
                  lowp: [14, 13, 20, 16, 14],
                  cloumn: [239, 265, 212, 260, 210],
                  cloumnp: [15, 17, 20, 15, 14]
                }
              },
              {
                url: img3,
                thicknesslist: {
                  low: [200, 251, 212, 267, 226],
                  lowp: [14, 13, 20, 16, 14],
                  cloumn: [235, 255, 212, 260, 210],
                  cloumnp: [15, 17, 20, 15, 14]
                }
              },
              {
                url: img4,
                thicknesslist: {
                  low: [210, 251, 212, 267, 246],
                  lowp: [],
                  cloumn: [239, 255, 212, 260, 210],
                  cloumnp: []
                }
              },
              {
                url: img5,
                thicknesslist: {
                  low: [210, 251, 212, 247, 216],
                  lowp: [14, 13, 20, 16, 14],
                  cloumn: [239, 255, 212, 230, 220],
                  cloumnp: [15, 17, 20, 15, 14]
                }
              }

            ]
          },
          {
            img: img10,
            list: [
              {
                url: img1,
                thicknesslist: {
                  low: [210, 251, 212, 260, 246, 221, 200],
                  lowp: [],
                  cloumn: [239, 255, 212, 260, 210, 321, 220],
                  cloumnp: []
                }
              },
              {
                url: img2,
                thicknesslist: {
                  low: [210, 261, 212, 267, 246],
                  lowp: [14, 13, 20, 16, 14],
                  cloumn: [239, 265, 212, 260, 210],
                  cloumnp: [15, 17, 20, 15, 14]
                }
              },
              {
                url: img3,
                thicknesslist: {
                  low: [200, 251, 212, 267, 226],
                  lowp: [14, 13, 20, 16, 14],
                  cloumn: [235, 255, 212, 260, 210],
                  cloumnp: [15, 17, 20, 15, 14]
                }
              },
              {
                url: img4,
                thicknesslist: {
                  low: [210, 251, 212, 267, 246],
                  lowp: [],
                  cloumn: [239, 255, 212, 260, 210],
                  cloumnp: []
                }
              },
              {
                url: img5,
                thicknesslist: {
                  low: [210, 251, 212, 247, 216],
                  lowp: [14, 13, 20, 16, 14],
                  cloumn: [239, 255, 212, 230, 220],
                  cloumnp: [15, 17, 20, 15, 14]
                }
              }

            ]
          }
        ]
      },
      imgHeight: 500,
      imgWidth: 500,
      patientdata: '',
      patientID: '',
      btnFlag: false,
      labelList: [],
      diagnosisList: [],
      drawFlag: false,
      findingList: [],
      labeloptions: [
        {
          options: [
            {
              value: 'AI label',
              label: 'AI label',
              disabled: false
            },
            {
              value: 'No AI label',
              label: 'No AI label',
              disabled: false
            }
          ]
        },
        {
          options: [
            {
              value: 'Approved',
              label: 'Approved',
              disabled: false
            },
            {
              value: 'Non-approved',
              label: 'Non-approved',
              disabled: false
            }
          ]
        },
        {
          options: [
            {
              value: 'Doctor label',
              label: 'Doctor label',
              disabled: false
            },
            {
              value: 'No doctor label',
              label: 'No doctor label',
              disabled: false
            }
          ]
        }
        // {
        //   options: [
        //     {
        //       value: '1202',
        //       label: '康醫生',
        //       disabled: false
        //     },
        //     {
        //       value: '1203',
        //       label: '黃醫生',
        //       disabled: false
        //     }
        //   ]
        // }
      ],
      diagnosisoptions: [
        {
          options: [
            {
              value: 0,
              label: 'No finding',
              disabled: false
            }
          ]
        },
        {
          options: [
            {
              value: 1,
              label: 'AMD',
              disabled: false
            },
            {
              value: 2,
              label: 'DME/RVO',
              disabled: false
            },
            {
              value: 4,
              label: 'MH',
              disabled: false
            },
            {
              value: 8,
              label: 'HM',
              disabled: false
            },
            {
              value: 16,
              label: 'RD',
              disabled: false
            },
            {
              value: 32,
              label: 'Other',
              disabled: false
            }
          ]
        }],
      findingoptions: [
        {
          value: '2',
          label: 'Pucker'
        },
        {
          value: '3',
          label: 'IRC'
        }, {
          value: '4',
          label: 'SRF'
        }, {
          value: '5',
          label: 'RPED'
        }, {
          value: '6',
          label: 'RPE atrophy'
        },
        // {
        //   value: '7',
        //   label: 'Skip'
        // },
        {
          value: '8',
          label: 'SRHM'
        }, {
          value: '9',
          label: 'Drusen'
        }, {
          value: '1',
          label: 'HF',
          new: true
        }
      ],
      form: [
        {
          imgSavePath: '00020.pat',
          list: []
        }
      ],
      centerDialogVisible: false,
      dialogVisible: false,
      // sliceData: {},
      imgIndex: 0,
      sliceImg: img1,
      drawData: {},
      filesList: [], /// 多层目录分组后数据
      AllFileList: [], // 所有数据
      md5List: [],
      percentage: 0, /// 当前上传的百分比
      customColorMethod: '#00A1AE',
      uploadedFile: 0, // 当前已上传文件数
      fileSizeTotal: 0,
      fileSizeUploaded: 0,
      filesTimeList: [],
      failedfilename: new Set(),
      successpatname: [], /// 上传成功的pat
      stepnum: 5,
      returnVisible: false,
      cancelUpload: false,
      interval: '',
      UploadFlag: false, // 所有文件上传成功
      Uploadloading: '',
      mode: 0, /// 手动上传，AI上传
      searchFlag: false, /// 记录是否点击过seach查询按钮，第一次点击时。记录当前scan和slice
      clearFlag: false, /// clearAll按钮：当其他搜索框按apply或search时，为true,点击ClearALL按钮后，清空并恢复到查询之前的状态
      cancelTokenList: [],
      progressReturnList: [],
      promiseReturnNumber: 0, /// 统计接口返回数量，多pat上传时处理返回结果
      showIndex: 0,
      uniqueIdList: [], /// 手动上传时,多个uniqueID获取返回数据
      paramsFilesList: []
    }
  },
  created () {
    window.addEventListener('keydown', this.keyfile, true)
  },
  beforeUnmount () {
    window.removeEventListener('keydown', this.keyfile, true)
  },
  mounted () {
    this.imgHeight = this.$refs.midBot.offsetHeight
    this.imgWidth = this.$refs.midBot.offsetWidth
    this.getDoctorList()
    // this.getData(0)
    window.onresize = () => {
      return (() => {
        this.imgHeight = this.$refs.midBot.offsetHeight > 800 ? this.$refs.midBot.offsetHeight : 800
        this.imgWidth = this.$refs.midBot.offsetWidth
      })()
    }
  },
  watch: {
    UploadFlag (newval, oldval) {
      if (newval) {
        this.returnVisible = false
        let time = 1000
        if (this.mode === 0) {
          this.Uploadloading = ElLoading.service({
            lock: true,
            text: 'data Loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          this.getData(0)
          this.interval = setInterval(() => {
            console.log('等待接口返回')
            if (this.$store.state.list.length === 0 && time >= 60000 * 2) {
              clearInterval(this.interval)
              this.Uploadloading.close()
              ElMessage({
                type: 'info',
                message: 'No data returned'
              })
            } else if (this.$store.state.list.length !== 0) {
              clearInterval(this.interval)
              this.Uploadloading.close()
            } else {
              // this.getData(0)
            }
            time += 1000
          }, time)
        } else {
          this.getData(1)
        }
      } else {
        clearInterval(this.interval)
      }
    },
    imgWidth: {
      async handler (newval, oldval) {
        if (newval) {
          for (const i in this.sliceData.list) {
            console.log('獲取圖片的真實寬高獲取圖片的真實寬高')
            await this.getImgInfo(this.sliceData.list[i], i)
          }
        }
      }
    },
    sliceData: {
      async handler (newval, oldval) {
        if (newval) {
          // for (const i in this.sliceData.list) {
            console.log('獲取圖片的真實寬高獲取圖片的真實寬高')
          if (this.sliceData&&this.sliceData.index) {
            await this.getImgInfo(this.sliceData.list[this.sliceData.index-1], this.sliceData.index-1)
          }
          // }
        }
      }
    },
    promiseReturnNumber (newval, oldval) {
      console.log('promiseReturnNumber', newval)
      console.log('this.progressReturnList', this.progressReturnList.length)
      if (newval === this.progressReturnList.length) {
        this.dialogVisible = false
        this.returnVisible = true
        /// 显示上传结果情况，再去抓取数据
        setTimeout(() => {
          if (!this.cancelUpload) {
            this.UploadFlag = true
          } else {
            this.UploadFlag = false
          }
        }, 1000)
      } else {
        if (this.progressReturnList[this.promiseReturnNumber - 1]) {
          this.progressReturnList[this.promiseReturnNumber - 1].showflag = false
        }
        if (this.progressReturnList[this.promiseReturnNumber]) {
          this.progressReturnList[this.promiseReturnNumber].showflag = true
        }
      }
    }
  },
  computed: {
    ...mapState(['sliceData']),
    // clearFlag () {
    //   if (this.patientdata !== '' || this.labelList.length !== 0 || this.diagnosisList.length !== 0 || this.findingList.length !== 0) { return true } else { return false }
    // },
    submitDisabled () {
      return this.md5List.length !== this.filesList.length
    },
    loading () {
      if (this.md5List.length === this.AllFileList.length) {
        let flag = true
        const ret = this.md5List.filter(item => item !== undefined)
        if (ret.length === this.AllFileList.length) {
          flag = false
        }
        return flag
      }
      return true
    },
    uploadedPatNumber () {
      const list = this.progressReturnList.filter((item) => item.percentage > 0)
      return list.length !== 0 ? list.length : 1
    }
  },
  methods: {
    /// 登出时，如果页面有未保存的数据，弹出提醒
    logoutSave () {
      if (this.$refs?.operatePart?.doSaveNowFun()) {
        window.sessionStorage.setItem('isLoginOut', true)
        return true
      } else {
        window.sessionStorage.removeItem('user')
        this.$router.push('/login')
        location.reload()
      }
    },

    /// 獲取圖片的真實寬高
    async getImgInfo (item, index) {
      const styleList = {
        width: this.imgWidth,
        height: this.imgHeight
      }
      // let width = this.imgWidth
      // let height=this.imgHeight
      const styleImg = await getImgStyle(item.url).then()
      // const preImg = Number((styleImg.imgWidth_T / styleImg.imgHeight_T).toFixed(2))
      // const preBox = Number((styleList.width / styleList.height).toFixed(2))
      // // console.log(preImg, preBox)
      // if (preImg < preBox) { /// 图片的比例小于box，以box的高为准，生成canvas
      //   height = Number(styleList.height)
      //   width = Number((styleList.height * preImg).toFixed(0))
      // } else {
      //   height = Number((styleList.width / preImg).toFixed(0))
      //   width = Number(styleList.width)
      // }
      /// 因为反馈不需要等比缩放，不介意图片被拉伸，所以传入宽高仍然以box styleList.width------20240305
      const obj = {
        index: index,
        list: {
          imgWidth_T: styleImg.imgWidth_T,
          imgHeight_T: styleImg.imgHeight_T,
          width: styleList.width, /// 还是以box宽高计算坐标
          height: styleList.height/// 还是以box宽高计算坐标
        }
      }
      this.$store.commit('setImgStyleInfo2', obj)
      // console.log('state.sliceData2',this.$store.state.sliceData)
    },
    async getDoctorList () {
      const { code, data } = await getDoctorList()
      if (code === 200) {
        const options = []
        data.forEach((item) => {
          const obj = {
            value: item.doctorName,
            label: item.doctorName,
            id: item.id,
            disabled: false
          }
          options.push(obj)
        })
        const ret = {
          options: options
        }
        this.labeloptions.push(ret)
      }
    },
    getData (type) { // type 0-手動 1-自動
      if (type === 0) { //
        this.$store.dispatch('getListData', this.uniqueIdList)
      } else { /// 自動模式下，每次都拉取雲端新數據
        // this.ClearAllFun()
        this.patientdata = ''
        this.labelList = []
        this.diagnosisList = []
        this.findingList = []
        let params = {}
        if (this.mode === 0) {
          params = {
            count: this.$store.state.count,
            start:1,
            length:this.$store.state.partDataLength
          }
        } else {
          params = {
            uniqueId: this.uniqueIdList, // this.$store.state.unique,
            count: this.$store.state.count,
            start:1,
            length:this.$store.state.partDataLength
          }
        }
        this.$store.dispatch('getAIListData', params)
      }
    },
    /// 按鈕刪除標誌
    deleteMark () {
      const e = {
        key: 'Delete',
        code: 46
      }
      window.onkeydown(e)
    },
    keyfile (e) {
      if (e.ctrlKey && e.keyCode === 79) {
        console.log('组合键，ctrl+o', e)
        e.preventDefault()
        this.btnChange(0)
      } else if (e.ctrlKey && e.keyCode === 82) {
        console.log('ctrl+r')
        e.preventDefault()
        if (this.btnFlag) {
          this.refreshFun()
        }
      }
    },
    /// 切換tab菜單
    changeLabelModel (data) {
      if (data === '1') {
        this.btnFlag = false
        // 发送请求，清空数据
        // if (this.$store.state.ManualList.length !== 0) {
        this.$store.commit('changeListToManualList')
        this.$store.commit('changeScan')
        // }
      } else if (data === '2-1') {
        this.btnFlag = true
        // 上传资料到云端
        console.log('上传资料到云端')
        setTimeout(() => {
          this.btnChange(2)
        }, 1)
      } else if (data === '2-2') {
        this.btnFlag = true
        // 从云端抓取数据
        this.getData(2)
        // this.$store.commit('changeScan')
        this.$refs.operatePart.scanNum = 1
      } else if (data === '2-3') { /// 获取下一批数据，20组
        this.btnFlag = true
        // 从云端抓取数据
        let count = this.$store.state.count
        if (this.$store.state.list.length !== 0 && this.$store.state.list[0].scanlist.length === 20) {
          count++
          this.$store.commit('setCount', count)
          this.getData(1)
          this.$refs.operatePart.scanNum = 1
        }
      }
    },
    ClearAllFun (type) {
      if (this.$refs.selectSearch1) {
        this.$refs.selectSearch1.handleClose()
        this.$refs.selectSearch2.handleClose()
        this.$refs.selectSearch3.handleClose()
      }

      switch (type) {
        case 0:
          this.labelList = []
          this.labelChange([])
          break
        case 1:
          this.diagnosisList = []
          this.diagnosisChange([])
          break
        case 2:
          this.findingList = []
          break
        default:

          this.patientdata = ''
          this.labelList = []
          this.diagnosisList = []
          this.findingList = []
          if (this.searchFlag) { /// searchFlag点击过搜索的
            // 查询新的数据，并将之前refreshData记录的位置还原
            const refreshData = JSON.parse(window.sessionStorage.getItem('refreshData'))

            // console.log('this.$store.', refreshData)
            this.$store.commit('setrefreshData', refreshData)
            this.$store.commit('setrefreshDataFlag', true)
            this.ApplySearch()
            this.searchFlag = false
            this.$refs.operatePart.scanNum = this.$store.state.scanIndex + 1
            // console.log('this.$store.', refreshData)
          }
          this.clearFlag = false
          break
      }
    },
    /// refresh--刷新當前的一批數據-AI模式下
    refreshFun () {
      const refreshData = {
        scanIndex: this.$store.state.scanIndex,
        sliceIndex: this.$store.state.sliceIndex
      }
      // window.sessionStorage.setItem('refreshData', JSON.stringify(refreshData))
      this.$store.commit('setrefreshData', refreshData)
      this.$store.commit('setrefreshDataFlag', true)
      this.patientdata = ''
      this.labelList = []
      this.diagnosisList = []
      this.findingList = []
      this.ApplySearch(1)// flag==1，只refresh数据，不是clearALL
    },
    /// 搜索
    ApplySearch (flag) {
      this.clearFlag = flag !== 1// flag==1，只refresh数据，不是clearALL
      if (!this.searchFlag) { /// 记录点击第一次搜索前，数据情况
        const refreshData = {
          scanIndex: this.$store.state.scanIndex,
          sliceIndex: this.$store.state.sliceIndex
        }
        window.sessionStorage.setItem('refreshData', JSON.stringify(refreshData))
        // this.$store.commit('setrefreshData', refreshData)
        // this.$store.commit('setrefreshDataFlag', true)
        console.log('2314133')
        this.searchFlag = true
      }
      if (this.$refs.selectSearch1) {
        this.$refs.selectSearch1.handleClose()
        this.$refs.selectSearch2.handleClose()
        this.$refs.selectSearch3.handleClose()
      }
      const AiIndex = this.labelList.findIndex(item => item === 'AI label')
      const AiIndex2 = this.labelList.findIndex(item => item === 'No AI label')
      const AiIndex1 = this.labelList.findIndex(item => item.includes('AI label'))
      const docIndex2 = this.labelList.findIndex(item => item.includes('octor label'))
      const docIndex = this.labelList.findIndex(item => item.includes('Doctor label'))
      const docIndex1 = this.labelList.findIndex(item => item.includes('No doctor label'))
      const apIndex = this.labelList.findIndex(item => item.includes('pproved'))
      const apIndex1 = this.labelList.findIndex(item => item.includes('Approved'))
      const apIndex2 = this.labelList.findIndex(item => item.includes('Non-approved'))
      let isAi = null
      isAi = AiIndex !== -1 ? 1 : isAi
      isAi = AiIndex2 !== -1 ? 0 : isAi
      let isHaveDoctor = null
      if (docIndex !== -1) {
        isHaveDoctor = 1
      }
      if (docIndex1 !== -1) {
        isHaveDoctor = 0
      }
      let isApproved = null
      if (apIndex1 !== -1) { /// Approved
        isApproved = 1
      }
      if (apIndex2 !== -1) { /// Non-approved
        isApproved = 0
      }
      const list = JSON.parse(JSON.stringify(this.labelList))
      if (AiIndex1 !== -1) {
        list.splice(AiIndex1, 1)
      }
      if (docIndex2 !== -1) {
        list.splice(docIndex2 - 1, 1)
      }
      if (apIndex !== -1) {
        list.splice(apIndex - 1, 1)
      }
      let listcopy = null
      if (list.length === 0) {
        listcopy = null
      } else {
        listcopy = list
      }
      let diagnosis = null
      for (let i = 0; i < this.diagnosisList.length; i++) {
        diagnosis += this.diagnosisList[i]
      }
      setTimeout(() => {
        const params = {
          uniqueId: null,
          count: this.$store.state.count,
          isAi: isAi,
          isHaveDoctor: isHaveDoctor,
          finding: this.findingList.length === 0 ? null : this.findingList,
          dacName: listcopy,
          patientId: this.patientdata ? this.patientdata : null,
          diagnosis: diagnosis,
          isApproved: isApproved,
          start:1,
          length:this.$store.state.partDataLength
          // realPatientld:this.patientID
        }
        this.$store.dispatch('getAIListData', params)
        // loading.close()

        this.$refs.operatePart.clearDraw()
      }, 1000)
    },
    /// 获取文件信息
    fileChange (e) {
      try {
        let fu = ''
        if (this.mode === 0) { fu = document.getElementById('file') } else { fu = document.getElementById('file2') }
        if (fu == null) return
        const list = []
        this.filesList = {}// []//fu.files
        this.md5List = []
        // console.log('fu', fu.files)
        // const imgSavePath = ''
        this.AllFileList = []
        this.centerDialogVisible = true
        /// 首先获取文件夹层级目录
        for (let i = 0; i < fu.files.length; i++) {
          if (fu.files[i].name.includes('.pdb') || fu.files[i].name.includes('.sdb') || fu.files[i].name.includes('.edb')) {
            const path = fu.files[i].webkitRelativePath.split('/')
            this.form.imgSavePath = path[0]
            const unipath = fu.files[i].webkitRelativePath.substring(0, fu.files[i].webkitRelativePath.lastIndexOf('/'))
            fu.files[i].unipath = unipath
            /// md5和时间封装到files去
            this.computeMD5(fu.files[i], i, unipath)
            fu.files[i].filesTime = formatTimeMills(fu.files[i].lastModifiedDate)
            list.push(fu.files[i].webkitRelativePath)
            this.AllFileList.push(fu.files[i])
          }
        }
        /// 按文件夹层级分类
        this.filesList = this.AllFileList.group((item) => item.unipath)
        this.form.list = list
      } catch (error) {
        console.debug('choice file err:', error)
      }
      console.log('this.filesList', this.filesList)
    },
    /// 點擊打開上傳
    btnChange (mode) {
      this.mode = mode
      let file = ''
      this.filesList = []
      this.percentage = 0
      this.form.imgSavePath = ''
      this.form.list = []
      if (mode === 0) {
        file = document.getElementById('file')
        file.value = ''
        file.click()
      } else {
        file = document.getElementById('file2')
        file.value = ''
        file.click()
      }
    },
    /// 点击上传
    async submitUpfile () {
      this.centerDialogVisible = false
      this.uploadedFile = 0
      this.promiseReturnNumber = 0
      this.progressReturnList = []
      this.successpatname = []
      this.failedfilename = new Set()
      this.uniqueIdList = []
      this.paramsFilesList = []
      this.UploadFlag = false
      /// 多个pat上传
      Object.keys(this.filesList).map(async (key) => {
        const u = key.split('/')
        const str = u[u.length - 1]
        const str2 = str.substring(0, str.lastIndexOf('.'))/// 截取uniqueID
        const obj = {
          patprogessKey: str2,
          patprogesslength: this.filesList[key].length,
          uploadedFile: 0,
          percentage: 0,
          showflag: false
        }
        this.uniqueIdList.push(str2)
        this.progressReturnList.push(obj)
        // this.paramsFilesList.push(this.filesList[key])
        // await this.uploadfile(this.filesList[key],key)
        // console.log('key',key)
        this.paramsFilesList.push(this.paramsData(this.filesList[key], key, str2))
        console.log('this.paramsFilesList', this.paramsFilesList)
      })
      this.dialogVisible = true
      for (let i = 0; i < this.paramsFilesList.length; i++) {
        await this.uploadFileFun(this.paramsFilesList[i].paramslist, this.paramsFilesList[i].headers, this.paramsFilesList[i].unique)
        console.log('this.promiseReturnNumber', this.promiseReturnNumber)
      }
    },
    /// 上传文件--pat为单位
    /// 封装请求参数--多pat
    paramsData (files, key, unique) {
      console.log('files, key', key)
      this.progressReturnList[0].showflag = true
      const count = files.length > 5 ? Math.ceil(files.length / 5) : 1// 文件數量大於5,調用多次，一次上傳5個文件
      this.$store.commit('setUnique', unique)
      const stepnum = files.length > 5 ? 5 : files.length
      this.stepnum = stepnum
      const headers = {
        'Content-Type': 'multipart/form-data',
        mode: this.mode, /// 0手动，1自动
        unique: unique,
        count: count
      }
      let index = 0

      this.uploadedFile = 0
      const paramslist = []
      const length = files.length
      /// 封装请求参数
      for (let i = 0; i < count; i++) {
        const list = []
        const md5li = []
        let step = index + stepnum
        if (step > length) { step = length }
        for (let j = index; j < step; j++) {
          list.push(files[j])
          const str = `${files[j].md5}#${files[j].filesTime}`
          md5li.push(str)
        }
        const params = {
          file: list,
          md5: md5li
        }
        paramslist.push(params)
        index = index + stepnum

        console.log(params)
      }
      const paramsdata = {
        headers: headers,
        unique: unique,
        paramslist: paramslist
      }
      return paramsdata
    },

    /// 发送请求-单个pat，但其中分为多个请求
    async uploadFileFun (paramslist, headers, unique) {
      const { code, msg } = await redisClear({ unique: unique })/// 清除redis缓存
      if (code === 200) {
        // setTimeout(async () => {
        let status = false
        await Promise.all(this.getDataBind(this.getpromiseData, paramslist, headers))
          .then(resultArr => {
            resultArr = resultArr.flat()// 拉平数组
            for (let i = 0; i < resultArr.length; i++) {
              if (resultArr[i].data.length !== 0) {
                if (resultArr[i].code === 200) {
                  this.failedfilename.add(...resultArr[i].data)
                  status = true
                } else {
                  status = false
                }
              }
            }
            console.log(status)
            // if (status) {
            this.successpatname.push(headers.unique)
            this.promiseReturnNumber++/// 多少个pat上传完成了
            // }
          }).catch((err) => {
            console.log('批量上传接口报错', err)
            const newA = new Set(this.uniqueIdList)
            const newB = new Set(this.successpatname)
            const arr = new Set([...newA].filter(x => !newB.has(x)))
            console.log('failedfilename', arr)
            this.failedfilename = arr
            this.dialogVisible = false
            this.returnVisible = false
            this.UploadFlag = false
            this.cancelUploadFun()
            ElMessage({
              type: 'error',
              message: '批量上传接口报错'
            })
          })
        console.log('接口请求发送完成！')
        // }, 2000)
      } else {
        console.log('msg', msg)
      }
    },

    // /// 上傳文件 ---单个pat
    // async uploadfile (files, key) {
    //   console.log('files, key', key)
    //   this.progressReturnList[0].showflag=true
    //   const count = files.length > 5 ? Math.ceil(files.length / 5) : 1// 文件數量大於5,調用多次，一次上傳5個文件
    //   const u = key.split('/')
    //   const str=u[u.length-1]
    //   // const u = this.form.imgSavePath.substring(0, this.form.imgSavePath.lastIndexOf('.'))
    //   const unique = `${str.substring(0, str.lastIndexOf('.'))}`
    //   this.$store.commit('setUnique', unique)
    //   const stepnum = files.length > 5 ? 5 : files.length
    //   this.stepnum = stepnum
    //   const headers = {
    //     'Content-Type': 'multipart/form-data',
    //     mode: this.mode, /// 0手动，1自动
    //     unique: unique,
    //     count: count
    //   }
    //   let index = 0

    //   this.uploadedFile = 0
    //   const paramslist = []
    //   const length = files.length
    //   /// 封装请求参数
    //   for (let i = 0; i < count; i++) {
    //     const list = []
    //     const md5li = []
    //     let step = index + stepnum
    //     if (step > length) { step = length }
    //     for (let j = index; j < step; j++) {
    //       list.push(files[j])
    //       const str = `${files[j].md5}#${files[j].filesTime}`
    //       md5li.push(str)
    //     }
    //     const params = {
    //       file: list,
    //       md5: md5li
    //     }
    //     paramslist.push(params)
    //     index = index + stepnum

    //     console.log(params)
    //   }
    //   const { code, msg } = await redisClear({ unique: unique })/// 清除redis缓存
    //   if (code === 200) {
    //     // setTimeout(async () => {
    //       this.failedfilename = []
    //      await Promise.all(this.getDataBind(this.getpromiseData, paramslist, headers))
    //         .then(resultArr => {
    //           resultArr = resultArr.flat()// 拉平数组
    //           console.log('resultArr', resultArr)
    //           for (let i = 0; i < resultArr.length; i++) {
    //             if (resultArr[i].data.length !== 0) {
    //               if (resultArr[i].code === 200) {
    //                 this.failedfilename.push(...resultArr[i].data)
    //               }
    //             }
    //           }
    //           this.promiseReturnNumber++///多少个pat上传完成了
    //           // this.dialogVisible = false
    //           // this.returnVisible = true
    //           // /// 显示上传结果情况，再去抓取数据
    //           // setTimeout(() => {
    //           //   if (!this.cancelUpload) {
    //           //     this.UploadFlag = true
    //           //   }else {
    //           //     this.UploadFlag = false
    //           //   }
    //           // }, 1000)
    //         // this.successDiaFun()
    //         }).catch((err) => {
    //           console.log('批量上传接口报错', err)
    //           this.dialogVisible = false
    //           this.returnVisible = false
    //           this.UploadFlag = false
    //           ElMessage({
    //             type: 'error',
    //             message: '批量上传接口报错'
    //           })
    //         })
    //       console.log('接口请求发送完成！')
    //     // }, 2000)
    //   } else {
    //     console.log('msg', msg)
    //   }
    //   console.log('this.failedfilename', this.failedfilename)
    // },

    // async uploadfile (files, md5s) {
    //   const count = this.filesList.length > 5 ? Math.ceil(this.filesList.length / 5) : 1// 文件數量大於5,調用多次，一次上傳5個文件
    //   // const unique = `${this.form.imgSavePath}_${(new Date()).getTime()}`
    //   const u = this.form.imgSavePath.substring(0, this.form.imgSavePath.lastIndexOf('.'))
    //   const unique = `${u}`
    //   this.$store.commit('setUnique', unique)
    //   const stepnum = this.filesList.length > 5 ? 5 : this.filesList.length
    //   this.stepnum = stepnum
    //   const headers = {
    //     'Content-Type': 'multipart/form-data',
    //     mode: this.mode, /// 0手动，1自动
    //     unique: unique,
    //     count: count
    //   }
    //   let index = 0

    //   this.uploadedFile = 0
    //   const paramslist = []
    //   const length = this.filesList.length
    //   /// 封装请求参数
    //   for (let i = 0; i < count; i++) {
    //     const list = []
    //     const md5li = []
    //     let step = index + stepnum
    //     if (step > length) { step = length }
    //     for (let j = index; j < step; j++) {
    //       list.push(this.filesList[j])
    //       const str = `${this.md5List[j]}#${this.filesTimeList[j]}`
    //       md5li.push(str)
    //     }
    //     const params = {
    //       file: list,
    //       md5: md5li
    //     }
    //     paramslist.push(params)
    //     index = index + stepnum
    //   }

    //   const { code, msg } = await redisClear({ unique: unique })/// 清除redis缓存
    //   if (code === 200) {
    //     setTimeout(async () => {
    //       Promise.all(this.getDataBind(this.getpromiseData, paramslist, headers))
    //         .then(resultArr => {
    //           resultArr = resultArr.flat()// 拉平数组
    //           console.log('resultArr', resultArr)
    //           this.failedfilename = []
    //           for (let i = 0; i < resultArr.length; i++) {
    //             if (resultArr[i].data.length !== 0) {
    //               if (resultArr[i].code === 200) {
    //                 this.failedfilename.push(...resultArr[i].data)
    //               }
    //             }
    //           }
    //           this.dialogVisible = false
    //           this.returnVisible = true
    //           /// 显示上传结果情况，再去抓取数据
    //           setTimeout(() => {
    //             if (!this.cancelUpload) {
    //               this.UploadFlag = true
    //             } else {
    //               this.UploadFlag = false
    //             }
    //           }, 1000)
    //         // this.successDiaFun()
    //         }).catch((err) => {
    //           console.log('批量上传接口报错', err)
    //           this.dialogVisible = false
    //           this.returnVisible = false
    //           this.UploadFlag = false
    //           ElMessage({
    //             type: 'error',
    //             message: '批量上传接口报错'
    //           })
    //         })
    //       console.log('接口请求发送完成！')
    //     }, 2000)
    //   } else {
    //     console.log('msg', msg)
    //   }
    //   console.log('this.failedfilename', this.failedfilename)
    // },
    /// 进度控制函数
    uploadProgress (ps) {
      if (ps.progress === 1) {
        this.uploadedFile = this.uploadedFile + this.stepnum
        this.percentage = Math.floor((this.uploadedFile / this.filesList.length) * 100)
      }
    },
    /// 生成请求接口批量封装
    getDataBind (func, params, headers) {
      return params.map(item => {
        return func(item, headers) // 传参
      })
    },
    /// 封装promise
    getpromiseData (params, headers) {
      this.cancelTokenList = []
      return new Promise(resolve => {
        batchUpload(params, headers, (ps) => {
          if (ps.progress === 1) {
            // this.uploadedFile = this.uploadedFile + params.file.length
            // this.percentage = Math.floor((this.uploadedFile / this.patprogesslength) * 100)
            this.progressReturnList.find((item, index) => {
              if (item.patprogessKey === headers.unique && item.uploadedFile < item.patprogesslength) {
                item.uploadedFile = item.uploadedFile + params.file.length
                item.percentage = Math.floor((item.uploadedFile / item.patprogesslength) * 100)
                // if (Math.floor((item.uploadedFile / item.patprogesslength) * 100) === 100) {
                //   item.showflag = false
                //   this.progressReturnList[index++].showflag=true
                // } else {
                //   item.showflag=true
                // }
              } else {
                // item.showflag=false
              }
            })
          }
        }).then(function (data) {
          resolve(data)
        }).catch((err) => {
          // params.file.forEach((item) => {
          //   this.failedfilename.push(item.name)
          // })
          // this.failedfilename.add(headers.unique)
          /// 计算出未成功上传的pat（取消上传的也包含）
          const newA = new Set(this.uniqueIdList)
          const newB = new Set(this.successpatname)
          const arr = new Set([...newA].filter(x => !newB.has(x)))
          console.log('failedfilename', arr)
          this.failedfilename = arr
          this.dialogVisible = false
          this.returnVisible = true
          this.UploadFlag = false
          this.cancelUploadFun()
          console.log(err)
        })
      })
    },
    cancelUploadFun () {
      this.returnVisible = true
      this.cancelUpload = false
      /// 删除上传操作
      this.cancelRequest('/file/batchUpload')
    },
    // api:要取消请求的接口（实际传的是接口路径url，这里是针对 上面的接口封装 来 截取 接口路径）
    cancelRequest (api) {
      /// file/batchUpload  url
      this.$store.state.axiosRequest.forEach((item, index) => {
        if (item.url.includes(api)) {
          item.cancel('已取消')
        }
      })
      this.$store.commit('clearaxiosRequest')
    },
    keepUploadFun () {
      this.returnVisible = false
      this.cancelUpload = false
      this.dialogVisible = true
    },
    handleClose () {
      this.dialogVisible = false
      this.returnVisible = false
      this.cancelUploadFun()
      // ElMessageBox.confirm(
      //   'Files will be cancelled for uploading. Continue?',
      //   'Warning',
      //   {
      //     confirmButtonText: 'OK',
      //     cancelButtonText: 'No',
      //     type: 'warning',
      //   }
      // ).then(() => {
      //     this.dialogVisible = false
      //     this.returnVisible = false
      //     this.cancelFun()
      //     // ElMessage({
      //     //   type: 'success',
      //     //   message: 'Delete completed',
      //     // })
      //   })
      //   .catch(() => {
      //   })
    },
    /// 标注事件
    drawFun (data) {
      // this.drawFlag = !this.drawFlag
      console.log('data2', data)
      setTimeout(() => {
        this.drawData = {
          drawFlag: data.drawFlag,
          color: data.color,
          text: data.text,
          id: data.id,
          doctor: this.$store.state.user.doctorName,
          originWidth: this.width, // 用於適配所化的框在不同的顯示屏上，大小位置一致，記錄的是化框時的圖片大小
          originHeight: this.height // 用於適配所化的框在不同的顯示屏上，大小位置一致，記錄的是化框時的圖片大小
        }
      }, 10)
    },
    /// 切片圖片切換
    changeSclie (obj) {
      // this.sliceImg = obj.url
      // this.imgIndex = obj.index
      // this.$store.commit('changeSliceIndex', obj.index)
      this.$store.dispatch('getSliceData', obj.index)
    },
    async changeNum (obj) {
      if (obj.flag === 'scan') { /// 切换切片
        /// 切换当前病患下的下一个scan
        // this.sliceData = this.datalist.scanlist[obj.index]
        const ret=await this.getPartData(this.$store.state,obj.index)
        this.drawData.drawFlag = false
        this.$store.commit('changeScan', obj.index)
        this.$refs.slicepart.sliceIndex = 0
      } else if (obj.flag === 'patient') { /// 切换病患
        this.$store.commit('changePatient', obj.index)
        this.$store.commit('changeScan', 0)
        this.$refs.slicepart.sliceIndex = 0
        // setTimeout(() => {
        //   this.drawData.drawFlag = false
        // })
      }
    },
    diagnosisChange (e) {
      const lastItem = e.pop()
      // const list = [1, 2, 4, 8, 16, 32]
      if (lastItem !== undefined) {
        if (lastItem === 0) {
          this.diagnosisList = [0]
        } else {
          e.push(lastItem)
          const li = e.indexOf(0)
          if (li !== -1) { e.splice(li, 1) }
        }
      }
    },
    labelChange (e) {
      // console.log(this.labelList)
      const lastItem = e.pop()
      console.log('lastItem', lastItem)
      let str = null
      if (lastItem) {
        if (lastItem.includes('AI')) { str = 'AI' } else if (lastItem.includes('pproved')) { str = 'pproved' } else if (lastItem.includes('octor')) { str = 'octor' }
        if (str) { /// 不是医生
          const Aindex = e.findIndex(item => item.includes(str))
          if (str === 'octor') {
            if (Aindex !== -1) { e.splice(Aindex, 1, lastItem) } else { e.push(lastItem) }
            const list = e.filter((item) => (!item.includes('AI') && !item.includes('pproved') && !item.includes('octor')))
            this.labelList = e.filter(item => !list.includes(item))
          } else {
            if (Aindex !== -1) { e.splice(Aindex, 1, lastItem) } else { e.push(lastItem) }
          }
        } else { /// 是某某医生
          const doInc = e.findIndex(item => item.includes('octor'))
          if (doInc !== -1) {
            e.splice(doInc, 1, lastItem)
          } else {
            e.push(lastItem)
          }
        }
        console.log('e2', e)
      }
    },
    /// 計算文件的md5值
    computeMD5 (param, i) {
      const file = param
      const sliceLength = 1024 * 1024 * 10/// // 切片默认大小10M
      let retMd5 = ''
      // let chunkSize = 0
      // if (file.size > sliceLength) {
      //   chunkSize = Math.ceil(file.size / sliceLength)
      // } else {
      //   chunkSize = file.size
      // }
      // console.log('chunkSize', chunkSize)
      const fileReader = new FileReader()
      const md5 = new SparkMD5()
      let index = 0
      const loadFile = () => {
        const slice = file.slice(index, index + sliceLength)
        fileReader.readAsBinaryString(slice)
      }
      loadFile()
      fileReader.onload = e => {
        md5.appendBinary(e.target.result)
        if (index < file.size) {
          // console.log('切片', index)
          index += sliceLength
          loadFile()
        } else {
          retMd5 = md5.end()// 就是文件md5码
          console.log(retMd5, i)
          param.md5 = retMd5
          // this.md5List[i] = retMd5
          this.md5List.push(retMd5)
        }
      }
    },
    //////新增逻辑，如果分批插入，当查询到接近无数据的index时，去获取数据
    async getPartData (state, payload) {
      if (state.list !== [] && state.list.length !== 0) {
        ///新增逻辑，如果分批插入，当查询到接近无数据的index时，去获取数据
        ///当前的跳转值没有数据---status 1
        const partIndexdata = state.list[this.$store.state.patientIndex].scanlist[payload]
        const have_data_part = state.list[this.$store.state.patientIndex].have_data_part
        const lengthNum = this.$store.state.partDataLength
        const total = state.list[this.$store.state.patientIndex].scanlist.length
        //输入跳转时，查找当前输入值输入那个区间范围---status 2
        let have = true
        let part_num=payload
        ///在往后还差第3个时，自动请求下一批数据---status 3
        for (let i = lengthNum; i <= total; i = i + lengthNum){
          if (payload+1>i&&payload+1<=i + lengthNum) {
            have = have_data_part.find((item) => (payload >= item.start && payload < (item.start + item.length - 1)))
            part_num = i
            console.log('part_num',part_num)
            break
          }
        }
        let have2 = true
        ///在往后还差第3个时，自动请求下一批数据---status 3
        for (let i = lengthNum; i <= total; i = i + lengthNum){
          if ((i - payload) === 5) {
            have2 = have_data_part.find((item) => (i + 1 >= item.start && i + 1 < (item.start + item.length - 1)))///提前获取
            break
          }
        }
        console.log('havehavehavehavehavehavehavehavehavehavehavehave',partIndexdata)
        console.log('havehavehavehavehavehavehavehavehavehavehavehave',have)
        console.log('havehavehavehavehavehavehavehavehavehavehavehave',have2)
        if (!partIndexdata) { ///输入跳转的情况--当前输入值无数据，需及时获取
          let params = {
            count: 1,
            start:part_num+1,
            length:this.$store.state.partDataLength
          }
          const options = {
            lock: true,
            text: 'Loading...',
            customClass: 'customClass',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          }
          const loading = ElLoading.service(options)
          await this.$store.dispatch('getAIListData', params)
          loading.close()
        } else if (!have2) {///无痕预加载下一批数据的情况
          let params = {
            count: 1,
            start:payload+6,
            length:this.$store.state.partDataLength
          }
          this.$store.dispatch('getAIListData', params)
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.box{
    width: 100%;
    // height: 100vh;
    flex:1;
    display: flex;
    justify-content: space-between;
    // height:calc(100% - 50px)
    // height: 100%;
}
.left{
    width: 22%;
    height:100%;
    min-width: 280px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
   >div{
     width:100% ;
    //  height: 25%;
     padding: .625rem 1.875rem;
   }
   .left_1{
    //  height: 20%;
    // border-bottom: 1px solid;
     .span{
        display: flex;
        justify-content: space-between;
         padding: .625rem 0;
        font-size: 16px;
        color: #2A2A2A;
     }
   }
   .left_2{
    //  height: 25%;
    // margin-top: 10px;
   }
   .left_2,.left_3{
    //  height: 25%;
    // border-bottom: 1px solid;
    p{
        text-align: left;
    }
   }
   .left_3{
     p{
        text-align: left;
     }
   }
   .left_4{
    //  width:100% ;
     height: 30%;
    // height: 300px;
    // height: 250px;
    // margin-top: 20px;
    p{
        text-align: left;
    }
   }
   .btn{
        display: flex;
        justify-content: center;
        .el-button{
            width: 99%;
            height: 43px;
            // margin-top: 10px;
            justify-content: center;
            font-size: 18px;
            font-weight: 700;
            background-color: #3AC0CB;
            color: #fff;
                img{
                    width: 25px;
                    margin-right: 3.75rem;
                }
        }
        .el-button:focus, .el-button:hover{
            border-color: #3EC9D4;
        }
   }
}
.mid{
    flex: 1;
    // height: 100vh;
    background-color: #F3F7F9;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    height: calc(100vh - 60px);
    .mid_top{
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-button{
            width: 100px;
            height: 40px;
            font-size: 18px;
            // float: right;
        }
        .selectClass{
           width: 20%; max-width: 180px;--el-color-primary:#3AC0CB;margin-right: 5px;
        }
        .selectClass2{
           width: 20%; max-width: 170px; --el-color-primary:#3AC0CB;margin-right: 5px;
        }
        .search{
            border-radius:0;width: 70px;--el-color-primary:#3AC0CB;font-size: 14px;color:#fff;background-color: #3AC0CB;height:30px;
        }
    }
    .mid_bot{
        flex:1;
        background-color: #000000;
        // max-height: 817px;
        // max-width: 1210px;
        img{
            // width: 100%;
            // height: 100%;
            // max-height: 100%;
        }
    }
}
@media screen and (min-width:1500px){
  .selectClass{
           width: 180px!important;
        }
}
@media screen and (min-height:1199px){
  .left_1{
    margin-top: -34px;
  }
  .left_2{
    margin-top: 120px;
  }
  .left_3{
    margin-top: 120px;
  }
}
.right{
    height: 100%;
    width: 15%;
    min-width: 230px;
    // height: 100vh;
    // background-color: yellow;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    >div{
        width: 100%;
        padding: .625rem 1.875rem;
    }
    .right_1{
        height:25%;
        // background-color: aqua;
        // border: 1px solid;
        .el-button{
            // justify-content:left;
            div{
                margin-right: 10px;
            }
        }
        .el-button+.el-button {
             margin-left: 0!important;
        }
    }
    .right_2{
        flex:1;
        // background-color: aqua;
        .el-button{
            // justify-content:left;
            div{
                margin-right: 10px;
            }
        }
        .el-button+.el-button {
             margin-left: 0!important;
        }
    }
    .right_3{
        height: 20%;
        // background-color: rgb(37, 78, 78);
        .el-button+.el-button {
             margin-left: 0!important;
        }
    }
}
</style>
<style lang="less">

.el-loading-spinner .el-loading-text{
  color:#3AC0CB!important;
  font-size: 18px!important;
}
.cancelDia {
  .el-dialog__header{
    text-align: left!important;;
  }
  text-align: left;
}
.el-select-dropdown__wrap{
        max-height: 500px!important;
}
.el-select-dropdown__item{
        margin-left: 20px;
    }
.el-select-dropdown.is-multiple .el-select-dropdown__item::after{
    display: none;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item::before{
        content: "";
        position: absolute;
        top: 50%;
        left: 0px;
        border-top: none;
        border-right: none;
        background-repeat: no-repeat;
        background-position: center;
        background-color: #BDBDBD;
        -webkit-mask: url(../assets/images/weigouxuan40.svg) no-repeat;
        mask: url(../assets/images/weigouxuan40.svg) no-repeat;
        mask-size: 100% 100%;
        /* -webkit-mask: url(data:image/svg+xml;utf8,%3Csvg class='icon' width='200' height='200' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='currentColor' d='M406.656 706.944L195.84 496.256a32 32 0 10-45.248 45.248l256 256 512-512a32 32 0 00-45.248-45.248L406.592 706.944z'%3E%3C/path%3E%3C/svg%3E) no-repeat; */
        -webkit-mask-size: 100% 100%;
        transform: translateY(-50%);
        width: 12px;
        height: 12px;
        }
        .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::before{
            content: "";
            position: absolute;
            top: 50%;
            left: 0px;
            border-top: none;
            border-right: none;
            background-repeat: no-repeat;
            background-position: center;
            background-color: var(--el-color-primary);
            -webkit-mask: url(../assets/images/gouxuan.svg) no-repeat;
            mask: url(../assets/images/gouxuan.svg) no-repeat;
            mask-size: 100% 100%;
            /* -webkit-mask: url(data:image/svg+xml;utf8,%3Csvg class='icon' width='200' height='200' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='currentColor' d='M406.656 706.944L195.84 496.256a32 32 0 10-45.248 45.248l256 256 512-512a32 32 0 00-45.248-45.248L406.592 706.944z'%3E%3C/path%3E%3C/svg%3E) no-repeat; */
            -webkit-mask-size: 100% 100%;
            transform: translateY(-50%);
            width: 12px;
            height: 12px;
        }
</style>
